import React from 'react';

import loadHomePage from 'bundle-loader?lazy&title=Gift%20Code!./components/routes/home-page';
import loadProductsPage from 'bundle-loader?lazy&title=Products!./components/routes/products-page';
import loadProductsListPage from 'bundle-loader?lazy&title=Products%20List!./components/routes/products-page/products-list-page';
import loadContactUs from 'bundle-loader?lazy&title=Contact%20Us!./components/routes/contact-us';
import LoadError from 'bundle-loader?lazy&title=Gift%20Code!./components/shared/error-display/genericError.jsx';

const Bundle = ( Component ) => (
	( props ) => (
		<Component { ...props } />
	)
);

export const routes = [ {
	pattern: '/error',
	load: LoadError
}, {
	title: 'giftCode.pageTitle.products',
	pattern: '/products/:browseCode?',
	load: loadProductsPage
}, {
	title: 'giftCode.pageTitle.products',
	pattern: '/products/:browseCode/products-list',
	load: loadProductsListPage
}, {
	title: 'giftCode.pageTitle.contactUs',
	pattern: '/contact',
	load: loadContactUs
}, {
	title: 'giftCode.pageTitle.giftCode',
	pattern: '/:giftCodeId?',
	load: loadHomePage
} ];

export const getMiddleware = () => {
	return [
		// Load Bundles
		( action, nextRoute, prevRoute ) => {
			const { match } = nextRoute;

			if (
				match &&
				!match.render &&
				typeof match.load === 'function'
			) {
				match.load( ( asyncModule ) => {
					match.render = Bundle( asyncModule.default ? asyncModule.default : asyncModule );
					action.ok();
				} );
			} else {
				action.ok();
			}
		}
	];
};
